var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoHomeWt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.615,
    height: 26.615,
    viewBox: "0 0 26.615 26.615",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M26.591,9.423,19.424,3.5a6.407,6.407,0,0,0-8.232,0L4.024,9.423A5.675,5.675,0,0,0,2,13.8v9.242a5.453,5.453,0,0,0,5.323,5.575H9.985a2.661,2.661,0,0,0,2.662-2.662V21.626a2.8,2.8,0,0,1,2.662-2.913,2.8,2.8,0,0,1,2.662,2.913v4.328a2.661,2.661,0,0,0,2.662,2.662h2.662a5.453,5.453,0,0,0,5.323-5.575V13.8A5.675,5.675,0,0,0,26.591,9.423Z",
    transform: "translate(-2 -2)",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHomeWt);
export default __webpack_public_path__ + "static/media/ico_home_wt.29cee301e8b57d381c0ab3455f362eed.svg";
export { ForwardRef as ReactComponent };